<template>
  <form @submit.prevent="submit">
    <fieldset :disabled="disabled">
      <div
        v-for="field in fields"
        :key="field.key"
        class="form-group"
      >
        <label
          class="form-label"
          :for="field.key"
        >
          {{ field.label }}
        </label>

        <input
          :id="field.key"
          v-model="passwords[field.key]"
          class="form-input"
          type="password"
          :autocomplete="field.autocomplete"
          required
          @input="error = ''"
        />
      </div>

      <p
        v-if="error"
        class="settings-error"
        role="alert"
      >
        {{ error }}
      </p>

      <button
        class="settings-submit"
        type="submit"
      >
        {{ getSubmitBtnText }}
      </button>
    </fieldset>
  </form>
</template>

<script>
const emptyPasswords = () => ({ currentPassword: '', newPassword: '', confirmPassword: '' })

export default {
  name: 'PasswordForm',
  props: {
    disabled: Boolean,
    saving: Boolean
  },
  data () {
    return {
      passwords: emptyPasswords(),
      error: '',
      fields: [
        {
          key: 'currentPassword',
          label: 'Текущий пароль',
          autocomplete: 'current-password'
        },
        {
          key: 'newPassword',
          label: 'Новый пароль',
          autocomplete: 'new-password'
        },
        {
          key: 'confirmPassword',
          label: 'Повторите новый пароль',
          autocomplete: 'new-password'
        }
      ]
    }
  },
  computed: {
    getSubmitBtnText () {
      return this.saving ? 'Сохранение…' : 'Сменить пароль'
    }
  },
  methods: {
    submit () {
      if (this.disabled) {
        return
      }

      const { currentPassword, newPassword, confirmPassword } = this.passwords

      if (newPassword !== confirmPassword) {
        this.error = 'Новые пароли не совпадают.'

        return
      }

      if (newPassword === currentPassword) {
        this.error = 'Новый пароль должен отличаться от текущего.'

        return
      }

      this.$emit('save', { currentPassword, newPassword })
    }
  }
}
</script>
